export enum DomainFeature {
  InstallationInstructionComponent = 'installationInstructionComponent',
}
